/**
 * Normalize an array to return a tuple
 * @param param0 Array
 * @returns A Tuple
 */
export const normalizeTuple = <Item>([first, second]: readonly Item[]) =>
	second === undefined ? ([first, first] as const) : ([first, second] as const);
